import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Chip, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import DragNDrop from "../drugs/DragNDrop";
import {Consts} from "../../pages/consts";

const GenesForSelecting = ({
                             patGenes,
                             onHandleInitNewTest,
                             availableGeneNames,
                             setAvailableGeneNames }) => {
  const { t } = useTranslation();
  const [selectedChipElems, setSelectedChipElems] = useState([]);
  const [enteringKind, setEnteringKind] = useState(Consts.MANUALLY);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    setSelectedChipElems(
      patGenes?.length > 0
        ? patGenes?.map((gene) => {
            return (
              <Chip
                value={gene}
                key={gene.geneName}
                label={<label className="chip-label">{gene.geneName}</label>}
                sx={{ backgroundColor: "#30c317", color: "#fff", margin: "5px" }}
                onDelete={() => handleDelete(gene)}
              />
            );
          })
        : [],
    );
  }, [patGenes]);

  const handleDelete = (gene) => {
    setAvailableGeneNames((availableGeneNames) => [
      ...availableGeneNames,
      gene.geneName,
    ]);

    if (patGenes?.length > 0) {
      const newArr = patGenes?.filter((g) => g.geneName !== gene.geneName);
      onHandleInitNewTest(newArr);
    }
  };

  const handleChipClick = (geneName) => {
    setAvailableGeneNames((availableGeneNames) =>
      availableGeneNames?.filter((name) => name !== geneName),
    );

    const newGene = {
      geneName: geneName,
      genotype: "",
      phenotype: "",
      phenoRisks: [],
      genoRisks: [],
      risks: []
    };

    onHandleInitNewTest(patGenes?.length > 0 ? [...patGenes, newGene] : [newGene]);
  };

  return (
    <div className="w3-padding-small w3-margin-top">
      <header className="w3-center w3-margin-top">
        <p>{t("please_select_the_genes_analysed_in_your_pgx_test")}</p>
      </header>
      <div className="w3-container form-content">
        <RadioGroup
          row
          aria-labelledby="pgx-upload-manually"
          name="pgx-upload-manually"
          value={enteringKind}
          defaultValue={enteringKind}
          onChange={(e) => setEnteringKind(e.target.value)}
        >
          <FormControlLabel
            value={Consts.UPLOAD}
            control={<Radio />}
            label={<label>{t("upload_file")}</label>}
          />
          <FormControlLabel
            value={Consts.MANUALLY}
            control={<Radio />}
            label={<label>{t("enter_manually")}</label>}
          />
        </RadioGroup>
        {enteringKind === Consts.UPLOAD && (
          <div className="w3-container">
            <DragNDrop onFilesSelected={setFiles} accept=".csv,.xls,.xlsx">
              {t("drag_and_drop_pgx_test")}
            </DragNDrop>
          </div>
        )}
        {enteringKind === Consts.MANUALLY && availableGeneNames?.length > 0 && (
          <div style={{minHeight: "50%"}}>
            <div className="w3-container">
              {availableGeneNames?.map((name) => (
                <Chip
                  key={name}
                  value={name}
                  label={<label className="chip-label">{name}</label>}
                  onClick={() => handleChipClick(name)}
                  sx={{ backgroundColor: "#1565a0", color: "#fff", margin: "5px" }}
                />
              ))}
            </div>
            <div className="hero-divider" aria-hidden="true" />
            {selectedChipElems?.length > 0 && (
              <div className="w3-container w3-padding">
                <label>{t("selected_genes")}:</label>
                <div className="w3-container">{selectedChipElems}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenesForSelecting;
